import {
    Component,
    OnInit,
    EventEmitter,
    Output,
    Input,
    HostListener,
    ElementRef,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    formatUiDate,
    getDateKey,
    parseDateTime,
} from 'src/app/shared/date/date.utils';
import { IDateRange } from 'src/app/interfaces/date-range.interfaces';
import {
    EHistoryEventsFiltersMode,
    IHistoryEvents,
    IHistoryEventsFilterParams,
    IHistoryFilter,
    IHistoryFilterItem,
    IHistoryItemHtmlList,
    IHistoryMainFilter,
} from 'src/app/interfaces/history.interfaces';
import { LoadService } from 'src/app/services/application/load.service';
import { HistoryService } from 'src/app/services/history.service';
import { AlertService } from 'src/lib/ariadna/alert';
import {
    dateToText,
    getDayWithYear,
    getNameDay,
    getTekDay,
    getTekDayNorm,
    getTime,
    strToDate,
} from '../../application/global.function';
import { PayPeriodDialogComponent } from '../../payments/dialogs/pay-period-dialog/pay-period-dialog.component';
import { HistoryItemComponentMobile } from 'src/app/modals/history-item-mobile/history-item.component';
import { ICalendarDateActive } from 'src/app/interfaces/calendar.interfaces';
import { ConfigService } from 'src/app/services/application/config.service.';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { LocationStrategy } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { HistoryPdfModal } from 'src/app/modals/history-pdf-modal/history-pdf.component';
import { DomSanitizer } from '@angular/platform-browser';
import { SemdModalComponent } from 'src/app/modals/semd-modal/semd-modal.component';

@Component({
    selector: 'app-list-completed',
    templateUrl: './list-completed.component.html',
    styleUrls: ['./list-completed.component.scss'],
    standalone: false,
})
export class ListCompletedComponent implements OnInit {
    public HistoryEvents: IHistoryEvents[] = [];
    @Output() public onDateGet = new EventEmitter<ICalendarDateActive[]>(); // получил данные
    public loading: boolean = false; // Загрузка талонов
    public showFilials = true; // Показ филиалов в таблице/фильтре. Параметр из АРМ
    // gridTemplateColumns = '9.5rem 1fr 9.5rem 1fr 1fr 4rem';
    public gridTemplateColumns = 'repeat(7, 1fr)';
    public _selectDate: string = ''; // выбранная дата

    @Input() public CountRecPage: number = 10;
    @Input() public filterChecked: boolean = false;
    @Output() public filterCheckedChange = new EventEmitter<boolean>();

    public CountRec: number = 0; // Всего записей
    public CurentPage: number = 1; // Текущая сраница

    public historyPages: Array<IHistoryEvents[]> = [];
    public date: IDateRange = { dt_begin: null, dt_end: null };

    public loadedPages = 1;
    public viewPage = 0;
    public periodText = 'За всё время';
    public countOfPages = 0;
    public historyListLength: number = 0; // Количество записей
    public countRecToPage = 10; // Количетсво записей на странице
    public loadingMoreContent = false;
    public pdfLoader = false;
    public isMobile: boolean = false;

    public filters: Record<'spec' | 'doc' | 'dep', IHistoryFilter> = {
        spec: {
            list: [] as IHistoryFilterItem[],
            mode: EHistoryEventsFiltersMode.SPEC,
            selectedID: null,
            searchText: '',
            loading: false,
        },
        doc: {
            list: [] as IHistoryMainFilter[],
            mode: EHistoryEventsFiltersMode.DOC,
            selectedID: null,
            searchText: '',
            loading: false,
        },
        dep: {
            list: [] as IHistoryFilterItem[],
            mode: EHistoryEventsFiltersMode.DEP,
            selectedID: null,
            searchText: '',
            loading: false,
        },
    };
    public originalData: Record<'spec' | 'doc' | 'dep', IHistoryFilter> = {
        spec: {} as IHistoryFilter,
        doc: {} as IHistoryFilter,
        dep: {} as IHistoryFilter,
    };

    private resizeHandler = () => {
        this.isMobile = window.innerWidth <= 767;

        this.cdr.detectChanges();
    };
    public pdfLoadingMap: Record<number, boolean> = {};

    public constructor(
        private router: Router,
        private hs: HistoryService,
        private dialog: MatDialog,
        private configS: ConfigService,
        private load: LoadService,
        private historyService: HistoryService,
        private alert: AlertService,
        private http: HttpNewService,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
    ) {
        this.showFilials =
            !!load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.HISTORY
                .HISTORY_SHOW_FILIALS;
        if (!this.showFilials)
            // this.gridTemplateColumns = '9.5rem 1fr 9.5rem 1fr 9rem 1fr';
            this.gridTemplateColumns = '1fr 23.5rem 1fr 1fr 1fr 1fr';
    }

    public async ngOnInit(): Promise<void> {
        this.periodText = this.getPeriodText(this.date);
        this.isMobile = window.innerWidth <= 767;
        // if (!this.isMobile) {
        this.loading = true;
        this.loadingMoreContent = true;
        // }

        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth <= 767;
            this.cdr.detectChanges();
        });
        window.addEventListener('scroll', () => this.onScroll());

        try {
            await this.getHistorySize(); // Получаем общее количество записей
            await this.loadInitialData(); // Загружаем первую страницу данных
            this.getHistoryFilters(); // Загружаем фильтры
            this.isInitialLoadComplete = true;
        } catch (error) {
            console.error('Error initializing component:', error);
        } finally {
            // this.loading = false;
            this.loadingMoreContent = false;
            this.cdr.detectChanges();
        }

        this.formatDateToString(this.date);
    }

    private async loadInitialData(): Promise<void> {
        if (this.isMobile) {
            await this.loadMoreHistory(1, this.countRecToPage);
        } else {
            await this.getListHistory(1, this.CountRecPage);
        }
    }

    public ngOnDestroy() {
        window.removeEventListener('scroll', () => this.onScroll());
        window.removeEventListener('resize', this.resizeHandler);
    }

    @ViewChild('#visitsContainer')
    public visitsContainer!: ElementRef;
    @HostListener('document:click', ['$event'])
    @HostListener('window:scroll', ['$event'])
    private scrollTimeout: any = null;
    public isInitialLoadComplete: boolean = false;

    public onScroll() {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            const visitsContainer = document.querySelector(
                '.list-completed-desktop__visits',
            );
            if (!visitsContainer) return;

            const lastVisitCard = visitsContainer.querySelector(
                '.visits__card:last-child',
            );
            if (!lastVisitCard) return;

            const rect = lastVisitCard.getBoundingClientRect();
            const windowHeight =
                window.innerHeight || document.documentElement.clientHeight;

            const isLastCardVisible =
                rect.bottom <= windowHeight &&
                rect.bottom > 0 &&
                this.loadedPages < this.countOfPages;

            if (isLastCardVisible && this.viewPage < this.CountRec) {
                this.loadNextPage();
            }
        }, 200);
    }

    public async getListHistory(pStart: number, pEnd: number): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                // Выполняем запрос с уже загруженными фильтрами
                this.fetchListHistory(pStart, pEnd, resolve, reject);
            } catch (error) {
                console.error('Error loading history filters:', error);
                this.alert.error('Не удалось загрузить фильтры', 3000);
                reject(error);
            }
        });
    }

    public isBlockYeer(index: number): boolean {
        if (index === 0) return true;

        return (
            this.HistoryEvents.length >= index + 1 &&
            this.HistoryEvents[index].dtSort?.getFullYear() !==
                this.HistoryEvents[index - 1].dtSort?.getFullYear()
        );
    }

    public getYeer(index: number): string {
        if (this.HistoryEvents && this.HistoryEvents[index]) {
            return this.HistoryEvents[index].dtSort?.getFullYear() + '';
        } else {
            return '';
        }
    }

    public getTekDay(dt: Date): string {
        return getTekDay(dt);
    }

    public getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    public getTime(dt: Date): string {
        return getTime(dt);
    }

    /* Смена страницы */
    public changedPage(page: number) {
        this.CurentPage = page;

        if (page === 1) {
            this.getListHistory(1, this.CountRecPage);
        } else {
            this.getListHistory(
                page * this.CountRecPage - this.CountRecPage + 1,
                page * this.CountRecPage,
            );
        }
    }

    // Formats
    public getTextDoc(doc: string) {
        const arr = doc.trim().split(' ');
        const [lastname, firstname, ...patronymParts] = doc.trim().split(' ');
        return `${lastname} ${firstname?.length ? firstname[0] + '.' : ''} ${
            patronymParts.join('').length ? patronymParts.join('')[0] + '' : ''
        }`;
    }
    public getDoctorName(doc: string) {
        if (!doc) return '';

        const parts = doc.trim().split(' ');
        if (parts.length < 2) return doc;

        const [lastname, firstname, secondname] = parts;
        return `${lastname || ''} ${firstname || ''} ${
            secondname || ''
        }`.trim();
    }

    public async loadNextPage() {
        // Проверяем условия для загрузки следующей страницы
        if (
            this.loadedPages / this.countOfPages !== 1 &&
            !this.loadingMoreContent
        ) {
            try {
                // Устанавливаем флаг загрузки

                if (this.isMobile) {
                    // Мобильная версия
                    this.loadingMoreContent = true;
                    await this.loadMoreHistory(
                        this.loadedPages * this.countRecToPage -
                            this.countRecToPage +
                            1,
                        this.loadedPages * this.countRecToPage,
                    );
                    // setTimeout(() => {
                    this.viewPage++;
                    this.loadingMoreContent = false;
                    // }, 100);
                } else {
                    this.loadingMoreContent = true;
                    // Десктоп версия
                    const nextPage = this.CurentPage + 1;
                    const currentItems = [...this.HistoryEvents];

                    await this.getListHistory(
                        nextPage * this.CountRecPage - this.CountRecPage + 1,
                        nextPage * this.CountRecPage,
                    );

                    // Добавляем новые элементы к существующим
                    this.HistoryEvents = [
                        ...currentItems,
                        ...this.HistoryEvents,
                    ];

                    this.CurentPage = nextPage;
                }

                this.loadedPages++;

                // Сбрасываем флаг загрузки
                this.loadingMoreContent = false;

                this.cdr.detectChanges();
            } catch (error) {
                console.error('Error loading next page:', error);

                // В случае ошибки
                this.loadingMoreContent = false;

                // Показываем уведомление об ошибке
                this.alert.error('Не удалось загрузить данные', 3000);

                this.cdr.detectChanges();
            }
        }
    }

    /** Изменение периода для вывода записей*/
    public async changePeriod(dt: IDateRange): Promise<void> {
        this.loadingMoreContent = true;
        this.date = dt;
        this.historyPages = [];
        this.loadedPages = 1;
        this.loadedPagesMobile = 0;
        this.viewPage = 1;
        this.pStart = 1;
        this.pEnd = this.countRecToPage;
        this.countOfPages = 0;
        try {
            await this.getHistorySize();
            await this.getHistoryFilters();
            this.formatDateToString(this.date);
            this.periodText = this.getPeriodText(this.date);

            // Загружаем только первую страницу
            await this.loadMoreHistory(this.pStart, this.pEnd);
        } finally {
            this.loadingMoreContent = false;
            this.cdr.detectChanges();
        }
    }

    // Функция для группировки приходящих данных по доктору, чтобы объединить дубли в единую структуру
    private normalizeDoctorsData(
        rawDocs: IHistoryFilterItem[],
    ): IHistoryFilterItem[] {
        const docMap = new Map<number, IHistoryMainFilter>();

        rawDocs.forEach((doc) => {
            if (docMap.has(doc.keyId)) {
                // Если доктор уже есть, добавляем workPlace
                const existing = docMap.get(doc.keyId);
                existing?.workPlaces?.push({
                    specId: Number(doc.specId),
                    depId: Number(doc.depId),
                });
            } else {
                // Если доктора нет, создаём нового
                docMap.set(doc.keyId, {
                    keyId: doc.keyId,
                    text: doc.text,
                    workPlaces: [
                        {
                            specId: Number(doc.specId),
                            depId: Number(doc.depId),
                        },
                    ],
                });
            }
        });

        return Array.from(docMap.values());
    }

    public async getHistoryFilters(): Promise<void> {
        // Устанавливаем флаги загрузки
        this.filters.spec.loading = true;
        this.filters.doc.loading = true;
        this.filters.dep.loading = true;

        try {
            // Параллельная загрузка фильтров
            const filterPromises = [
                lastValueFrom(
                    this.hs.getHistoryEventsFilter({
                        beginDate: null,
                        endDate: null,
                        mode: EHistoryEventsFiltersMode.SPEC,
                    }),
                ),
                lastValueFrom(
                    this.hs.getHistoryEventsFilter({
                        beginDate: null,
                        endDate: null,
                        mode: EHistoryEventsFiltersMode.DOC,
                    }),
                ),
                lastValueFrom(
                    this.hs.getHistoryEventsFilter({
                        beginDate: null,
                        endDate: null,
                        mode: EHistoryEventsFiltersMode.DEP,
                    }),
                ),
            ];

            const [specData, docData, depData] =
                await Promise.all(filterPromises);

            // Обновляем фильтры
            this.filters.spec.list = specData;
            this.filters.doc.list = this.normalizeDoctorsData(docData);
            this.filters.dep.list = depData;

            // Сбрасываем флаги загрузки
            this.filters.spec.loading = false;
            this.filters.doc.loading = false;
            this.filters.dep.loading = false;

            // Сохраняем оригинальные данные
            this.originalData = JSON.parse(JSON.stringify(this.filters));
        } catch (error) {
            console.error('Ошибка загрузки фильтров:', error);

            // Сбрасываем флаги загрузки
            this.filters.spec.loading = false;
            this.filters.doc.loading = false;
            this.filters.dep.loading = false;

            // Показываем уведомление об ошибке
            this.alert.error('Не удалось загрузить фильтры', 3000);

            // Генерируем исключение для обработки в вызывающем коде
            throw error;
        }
    }

    public async getHistorySize() {
        try {
            const [resHistory] = await Promise.all([
                await lastValueFrom(
                    this.hs.getHistoryEventsSize({
                        beginDate: this.date.dt_begin,
                        endDate: this.date.dt_end,
                        specId: this.filters.spec.selectedID,
                        docId: this.filters.doc.selectedID,
                        depId: this.filters.dep.selectedID,
                    }),
                ),
            ]);

            this.CountRec = resHistory.size;
            this.CountRec;

            this.setCountOfPagesMobile();
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка услуг');
        }
    }
    public pStart: number = 1;
    public pEnd: number = 10;
    public loadedPagesMobile: number = 0;

    public get HistoryItems(): IHistoryEvents[] {
        return this.historyPages.flat();
    }
    /** Подгрузка дополнительного кол-ва услуг */
    public async loadMoreHistory(pStart?: number, pEnd?: number) {
        // if (!this.isInitialLoadComplete || !pStart || !pEnd) return;

        try {
            this.loadingMoreContent = true;
            const res = await lastValueFrom(
                this.historyService.getHistoryEvents(
                    this.date.dt_begin,
                    this.date.dt_end,
                    pStart,
                    pEnd,
                    this.filters.spec.selectedID,
                    this.filters.doc.selectedID,
                    this.filters.dep.selectedID,
                ),
            );

            res.forEach((item) => {
                item.dtSort = new Date(
                    item.dat.replace(/(\d+).(\d+).(\d+)/, '$3/$2/$1'),
                );
            });

            // Проверка на уникальность
            const existingIds = new Set(
                this.historyPages.flat().map((item) => item.keyId),
            );
            const filteredRes = res.filter(
                (item) => !existingIds.has(item.keyId),
            );

            if (filteredRes.length > 0) {
                this.historyPages.push(filteredRes);
                this.pStart += 10;
                this.pEnd += 10;
                this.loadedPagesMobile++;
                this.viewPage++;
                this.loadedPages++;
            } else {
                this.countOfPages = this.loadedPagesMobile;
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка посещений');
            throw error;
        } finally {
            this.loadingMoreContent = false;
            this.loading = false;
            this.cdr.detectChanges();
        }
    }

    private fetchListHistory(
        pStart: number,
        pEnd: number,
        resolve: () => void,
        reject: (error: any) => void,
    ) {
        try {
            // this.loading = true;
            let dtHistory: Date | null = null;
            if (this._selectDate && this._selectDate.length > 4) {
                dtHistory =
                    parseDateTime(this._selectDate, 'yyyy-MM-dd')?.toJSDate() ??
                    null;
            }

            this.hs
                .getHistoryEvents(
                    dtHistory,
                    dtHistory,
                    pStart,
                    pEnd,
                    this.filters.spec.selectedID,
                    this.filters.doc.selectedID,
                    this.filters.dep.selectedID,
                )
                .subscribe({
                    next: (res) => {
                        try {
                            this.HistoryEvents = res;
                            let dt: ICalendarDateActive[] = [];

                            this.HistoryEvents.forEach((item) => {
                                item.dtSort = strToDate(item.dat);
                                dt.push({
                                    date: Number(getDateKey(item.dtSort)),
                                });
                            });

                            if (!dtHistory) {
                                this.onDateGet.emit(dt);
                            }
                            resolve();
                        } catch (processingError) {
                            console.error(
                                'Error processing history events:',
                                processingError,
                            );
                            reject(processingError);
                        }
                    },
                    error: (err) => {
                        console.error('Error fetching history events:', err);
                        this.alert.error('Не удалось загрузить историю', 3000);
                        reject(err);
                    },
                    complete: () => {
                        this.loading = false;
                        this.cdr.detectChanges();
                    },
                });
        } catch (error) {
            console.error('Unexpected error in fetchListHistory:', error);
            this.loading = false;
            this.alert.error(
                'Непредвиденная ошибка при загрузке истории',
                3000,
            );
            reject(error);
            this.cdr.detectChanges();
        }
    }

    /**
     * Фильтрация записей по дате

     */
    // btnFilterByDay(
    //     startOffset: number | null = 0,
    //     endOffset: number | null = 0,
    // ) {
    //     if (startOffset !== null && endOffset !== null) {
    //         this.date.dt_begin = new Date();
    //         this.date.dt_begin.setDate(
    //             this.date.dt_begin.getDate() - startOffset,
    //         );
    //         this.date.dt_end = new Date();
    //         this.date.dt_end.setDate(this.date.dt_end.getDate() - endOffset);
    //         this.changePeriod({
    //             dt_begin: this.date.dt_begin,
    //             dt_end: this.date.dt_end,
    //         });
    //     } else {
    //         this.changePeriod({ dt_begin: null, dt_end: null });
    //     }
    // }

    // getTekDayNorm(dt: Date): string {
    //     return getTekDayNorm(dt);
    // }

    /** Получение времени формата "D MM YYYY" */
    public getDayWithYear(dtSort: Date) {
        return getDayWithYear(dtSort);
    }

    /** Получение периода с полным названием месяца */
    public formatDateToString(dt: IDateRange) {
        if (dt.dt_begin) {
            dt.str_begin = formatUiDate(dt.dt_begin);
        }
        if (dt.dt_end) {
            dt.str_end = formatUiDate(dt.dt_end);
        }
    }

    /** Установка количества страниц*/
    public setCountOfPagesMobile() {
        this.countOfPages = Math.ceil(this.CountRec / this.countRecToPage);
        this.viewPage = 0;
    }

    /** Вызов диалога для выбора периода */
    public showPeriodDialog() {
        const periodDialog = this.dialog.open(PayPeriodDialogComponent, {
            maxWidth: '650px',
            width: '100%',
            height: '100%',
            data: {
                dateRange: {
                    dt_begin: this.date.dt_begin,
                    dt_end: this.date.dt_end,
                } as IDateRange,
            },
        });

        periodDialog.afterClosed().subscribe((result: any) => {
            if (result?.date) {
                this.loading = true;
                this.changePeriod(result.date).then(
                    () => (this.loading = false),
                );
            }
        });
    }

    /** Вызов диалога с деталями услуги */
    public showDetailsDialog(history: IHistoryEvents) {
        if (history.hasSemd && history.hasSemd > 0) {
            return lastValueFrom(
                this.http.get<Array<string> | string>(
                    `/history/events/item/semd?tp=${history.typeHistory}&id=${history.keyId}&isNeedPdf=0&sort=0`,
                ),
            )
                .then((pdf) => {
                    const safeHtml = [];
                    for (const part of pdf) {
                        safeHtml.push(
                            this.sanitizer.bypassSecurityTrustHtml(part),
                        );
                    }
                    const modal = this.modalService.open(SemdModalComponent, {
                        size: 'large',
                    });
                    modal.componentInstance.data = safeHtml;
                    this.setPdfLoading(history.keyId, false);
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {});
        }
        const dialogRef = this.dialog.open(HistoryItemComponentMobile, {
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
            closeOnNavigation: true,
            data: history,
        });

        return dialogRef.afterOpened().subscribe(() => {
            const dialogContent = document.querySelector(
                '.cdk-global-overlay-wrapper',
            ) as HTMLElement;
            if (dialogContent) {
                dialogContent.style.alignItems = 'unset';
            }
        });
    }
    /** Полученеи текста из периода */
    public getPeriodText(dt: IDateRange) {
        let periodText = '';
        let isSelectedOneDay = dt.str_begin === dt.str_end;

        if (isSelectedOneDay) {
            if (dt.dt_begin == null && dt.dt_end == null)
                periodText = 'За всё время';
            else if (dt.dt_begin?.toDateString() === new Date().toDateString())
                periodText = 'Последние посещения';
            else if (dt.str_begin) periodText = dt.str_begin;
        } else if (dt.str_begin && dt.str_end) {
            periodText = `${dt.str_begin} - ${dt.str_end}`;
        } else if (dt.str_begin) {
            periodText = dt.str_begin;
        } else if (dt.str_end) {
            periodText = dt.str_end;
        }

        return periodText;
    }

    /**
     * Фильтрация записей по дате
     * @param {number | null} startOffset Сдвиг даты С
     * @param {number | null} endOffset Сдвиг даты ПО
     */
    public btnFilterByDate(
        startOffset: number | null = 0,
        endOffset: number | null = 0,
    ) {
        if (startOffset !== null && endOffset !== null) {
            this.date.dt_begin = new Date();
            this.date.dt_begin.setDate(
                this.date.dt_begin.getDate() - startOffset,
            );
            this.date.dt_end = new Date();
            this.date.dt_end.setDate(this.date.dt_end.getDate() - endOffset);
            this.loading = true;
            this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            }).then(() => (this.loading = false));
        } else {
            this.date.dt_begin = null;
            this.date.dt_end = null;
            this.loading = true;
            this.changePeriod({ dt_begin: null, dt_end: null }).then(() => {
                this.loading = false;
            });
        }
    }
    public get isAnyFilterActive(): boolean {
        return (
            this.filters.spec.selectedID !== null ||
            this.filters.doc.selectedID !== null ||
            this.filters.dep.selectedID !== null
        );
    }

    public onChangeFilter(
        id: number | null,
        mode: EHistoryEventsFiltersMode,
        event?: Event,
    ) {
        if (event) event.stopPropagation();

        // Обновляем selectedID и searchText
        switch (mode) {
            case EHistoryEventsFiltersMode.SPEC:
                this.filters.spec.selectedID = id;
                this.filters.spec.searchText =
                    id !== null
                        ? this.originalData.spec.list.find(
                              (s) => s.keyId === id,
                          )?.text || ''
                        : '';
                break;
            case EHistoryEventsFiltersMode.DOC:
                this.filters.doc.selectedID = id;
                this.filters.doc.searchText =
                    id !== null
                        ? this.originalData.doc.list.find((d) => d.keyId === id)
                              ?.text || ''
                        : '';
                break;
            case EHistoryEventsFiltersMode.DEP:
                this.filters.dep.selectedID = id;
                this.filters.dep.searchText =
                    id !== null
                        ? this.originalData.dep.list.find((d) => d.keyId === id)
                              ?.text || ''
                        : '';
                break;
        }

        // Пересчитываем все фильтры
        this.recalculateFilters();

        // Закрываем dropdown'ы
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = false;
        this.isDepDropdownOpen = false;

        // Перезагружаем посещения
        this.loading = true;
        this.historyPages = [];
        this.viewPage = 0;
        this.loadedPages = 0;
        this.pStart = 1;
        this.pEnd = 10;

        this.getHistorySize()
            .then(() => {
                if (this.isMobile) {
                    this.loadMoreHistory(1, this.countRecToPage);
                } else {
                    this.changedPage(1);
                }
            })
            .catch((error) => {
                console.error('Error loading history:', error);
                this.loading = false;
            });
    }

    private recalculateFilters(): void {
        // 1. Получаем оригинальные списки из базы
        const allSpecs = this.originalData.spec.list as IHistoryFilterItem[];
        const allDocs = this.originalData.doc.list as IHistoryMainFilter[];
        const allDeps = this.originalData.dep.list as IHistoryFilterItem[];

        // 2. Фильтруем докторов на основе выбранных специальности и депа
        let availableDocs = allDocs;

        if (
            this.filters.spec.selectedID !== null &&
            this.filters.dep.selectedID !== null
        ) {
            availableDocs = availableDocs.filter((d) =>
                d.workPlaces?.some(
                    (w) =>
                        w.specId === this.filters.spec.selectedID &&
                        w.depId === this.filters.dep.selectedID,
                ),
            );
        } else if (this.filters.spec.selectedID !== null) {
            availableDocs = availableDocs.filter((d) =>
                d.workPlaces?.some(
                    (w) => w.specId === this.filters.spec.selectedID,
                ),
            );
        } else if (this.filters.dep.selectedID !== null) {
            availableDocs = availableDocs.filter((d) =>
                d.workPlaces?.some(
                    (w) => w.depId === this.filters.dep.selectedID,
                ),
            );
        }

        // 3. Проверяем валидность выбранного доктора
        if (this.filters.doc.selectedID !== null) {
            const isDocValid = availableDocs.some(
                (d) => d.keyId === this.filters.doc.selectedID,
            );
            if (!isDocValid) {
                this.filters.doc.selectedID = null;
                this.filters.doc.searchText = '';
            }
        }

        // 4. Определяем выбранного доктора(ов) (все доступные или только выбранный)
        let activeDocs = availableDocs;
        if (this.filters.doc.selectedID !== null) {
            activeDocs = availableDocs.filter(
                (d) => d.keyId === this.filters.doc.selectedID,
            );
        }
        // 4.1 фильтруем workPlaces, если выбрана спец или деп
        const activeWP = activeDocs.flatMap((d) => {
            let wp = d.workPlaces || [];

            if (this.filters.dep.selectedID !== null)
                wp = wp.filter((w) => w.depId === this.filters.dep.selectedID);
            if (this.filters.spec.selectedID !== null)
                wp = wp.filter(
                    (w) => w.specId === this.filters.spec.selectedID,
                );
            return wp;
        });

        // 5. На основе активных докторов находим доступные специальности и депы
        const specIdsFromActiveDocs = new Set(activeWP.map((ws) => ws.specId));
        let availableSpecs = allSpecs.filter((s) =>
            specIdsFromActiveDocs.has(s.keyId),
        );

        const depIdsFromActiveDocs = new Set(activeWP.map((wd) => wd.depId));
        let availableDeps = allDeps.filter((d) =>
            depIdsFromActiveDocs.has(d.keyId),
        );

        // 6. Проверяем валидность выбранных специальности и депа
        if (this.filters.spec.selectedID !== null) {
            const isSpecValid = availableSpecs.some(
                (s) => s.keyId === this.filters.spec.selectedID,
            );
            if (!isSpecValid) {
                this.filters.spec.selectedID = null;
                this.filters.spec.searchText = '';
            }
        }
        if (this.filters.dep.selectedID !== null) {
            const isDepValid = availableDeps.some(
                (d) => d.keyId === this.filters.dep.selectedID,
            );
            if (!isDepValid) {
                this.filters.dep.selectedID = null;
                this.filters.dep.searchText = '';
            }
        }

        // 7. Обновляем списки фильтров
        this.filters.doc.list = availableDocs;
        this.filters.spec.list = availableSpecs;
        this.filters.dep.list = availableDeps;
    }

    // Fires by press "ENTER" or click cross(clear)
    public async onSearchFilter(mode: EHistoryEventsFiltersMode, event: Event) {
        event.stopPropagation();
        const elem = event.target as HTMLInputElement;
        if (elem.value) return; // Skip "ENTER"

        await this.onChangeFilter(null, mode);
    }

    public async gotToDownload(
        id: number,
        tp: string,
        $event: MouseEvent,
        has_semd = 0,
    ) {
        $event.stopPropagation();
        this.setPdfLoading(id, true);

        // Синхронно создаём iframe
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.setAttribute(
            'sandbox',
            'allow-same-origin allow-scripts allow-downloads',
        );
        document.body.appendChild(iframe);

        let cleaned = false;
        const cleanup = () => {
            if (!cleaned) {
                cleaned = true;
                setTimeout(() => {
                    if (iframe.parentNode) {
                        document.body.removeChild(iframe);
                    }
                }, 2000);
            }
        };

        try {
            let blob: string;

            if (has_semd && has_semd > 0) {
                blob = await lastValueFrom(
                    this.http.get<string>(
                        `/history/events/item/semd?tp=${tp}&id=${id}&isNeedPdf=1&sort=0`,
                    ),
                );
            } else {
                const statePdfFull: number = this.load.configData
                    ?.CLIENT_SETTINGS.PAGES_SETTINGS.HISTORY
                    .HISTORY_VISIT_GET_ADDED_DOCUMENTS_ENABLED
                    ? 1
                    : 0;

                if (statePdfFull === 1) {
                    const res = await lastValueFrom(
                        this.http.get<Map<string, ArrayBuffer>>(
                            `/history/events/item/visitpdf/${tp}/${id}`,
                            null,
                            false,
                        ),
                    );
                    cleanup();
                    this.dialog.open(HistoryPdfModal, {
                        width: 'auto',
                        height: 'auto',
                        closeOnNavigation: true,
                        data: res,
                    });
                    this.setPdfLoading(id, false);
                    return;
                } else {
                    const res: string | undefined | IHistoryItemHtmlList =
                        await lastValueFrom(
                            this.http.get<
                                string | IHistoryItemHtmlList | undefined
                            >(this.getDownloadUrlForPDF(id, tp), null, false),
                        );
                    if (
                        typeof res === 'object' &&
                        res.linkOrHtmlFlag === 'link'
                    ) {
                        const pdf = await lastValueFrom(
                            this.http.post<string>(
                                '/history/events/visit/api',
                                { url: res.text },
                                true,
                            ),
                        );
                        blob = pdf;
                    } else {
                        blob = res as string;
                    }
                }
            }

            // Подставляем blob в iframe на скачивание
            const cleanBase64 = blob.replace(
                /^data:application\/pdf;base64,/,
                '',
            );
            const iframeDoc =
                iframe.contentDocument || iframe.contentWindow?.document;
            iframeDoc?.write(`
            <html>
                <body>
                    <a id="dl"
                       href="data:application/pdf;base64,${cleanBase64}"
                       download="document.pdf">
                    </a>
                    <script>
                        document.getElementById('dl').click();
                    </script>
                </body>
            </html>
        `);
            iframeDoc?.close();

            cleanup();
        } catch (error) {
            cleanup();
            console.log(error);
            this.alert.error('Ошибка загрузки');
        } finally {
            this.setPdfLoading(id, false);
        }
    }

    public getDownloadUrlForPDF(id: number, tp: string) {
        return `/history/events/item/${tp}/${id}.pdf`;
    }

    public resetFilters() {
        // Сбрасываем все фильтры до их исходного состояния
        this.filters.spec.list = [...this.originalData.spec.list];
        this.filters.doc.list = [...this.originalData.doc.list];
        this.filters.dep.list = [...this.originalData.dep.list];

        // Сбрасываем выбранные ID и поисковые тексты
        this.filters.spec.selectedID = null;
        this.filters.doc.selectedID = null;
        this.filters.dep.selectedID = null;

        this.filters.spec.searchText = '';
        this.filters.doc.searchText = '';
        this.filters.dep.searchText = '';

        // Сообщаем, что фильтры неактивны родительскому компоненту
        this.filterCheckedChange.emit(false);

        // Очищаем массивы с данными
        this.HistoryEvents = [];
        this.historyPages = new Array<IHistoryEvents[]>();

        // Полностью сбрасываем переменные пагинации
        this.viewPage = 0;
        this.loadedPages = 1;
        this.loadedPagesMobile = 0;
        this.pStart = 1;
        this.pEnd = 10;
        this.CurentPage = 1;

        // Пересчитываем количество страниц и загружаем данные
        this.loading = true;

        // Сначала получаем общее количество записей
        this.getHistorySize()
            .then(() => {
                // Затем загружаем первую страницу данных
                if (this.isMobile) {
                    // this.loadMoreHistory(1, this.countRecToPage);
                    this.getListHistory(1, this.CountRecPage);
                } else {
                }
                this.cdr.detectChanges();
            })
            .finally(() => {
                this.loading = false;
                this.cdr.detectChanges();
            });
    }

    public applyFilters() {
        const hasActiveFilter =
            this.filters.spec.selectedID !== null ||
            this.filters.doc.selectedID !== null ||
            this.filters.dep.selectedID !== null;

        this.filterChecked = false;
        this.filterCheckedChange.emit(hasActiveFilter);
        this.loading = false;
        this.viewPage = 0;
        this.loadedPages = 1;
        this.loadedPagesMobile = 0;
        this.pStart = 1;
        this.pEnd = 10;
        this.CurentPage = 0;
        this.CountRec = 0;
        this.setCountOfPagesMobile();
        this.historyPages = [];
        this.getHistorySize();
    }

    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: MouseEvent) {
        // this.closeDropdown(event);
    }
    public isSpecDropdownOpen = false;
    public isDocDropdownOpen = false;
    public isDepDropdownOpen = false;

    public toggleSpecDropdown(event: Event) {
        event.stopPropagation(); // Остановка всплытия события
        this.isSpecDropdownOpen = !this.isSpecDropdownOpen;
        this.isDocDropdownOpen = false;
        this.isDepDropdownOpen = false;
    }

    public toggleDocDropdown(event: Event) {
        event.stopPropagation();
        this.isDocDropdownOpen = !this.isDocDropdownOpen;
        this.isSpecDropdownOpen = false;
        this.isDepDropdownOpen = false;
    }

    public toggleDepDropdown(event: Event) {
        event.stopPropagation();
        this.isDepDropdownOpen = !this.isDepDropdownOpen;
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = false;
    }
    // отдельно для десктопа, специальности
    public onSpecInputFocus() {
        this.isDepDropdownOpen = false;
        this.isSpecDropdownOpen = true;
        this.isDocDropdownOpen = false;
    }
    public onSpecDropdownOpened() {
        this.isDepDropdownOpen = false;
        this.isSpecDropdownOpen = true;
        this.isDocDropdownOpen = false;
    }
    public onSpecDropdownClosed() {
        this.isSpecDropdownOpen = false;
    }
    // филиалы
    public onDepInputFocus() {
        this.isDepDropdownOpen = true;
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = false;
    }
    public onDepDropdownOpened() {
        this.isDepDropdownOpen = true;
        // Закрываем другие дропдауны
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = false;
    }
    public onDepDropdownClosed() {
        this.isDepDropdownOpen = false;
    }
    // доктора
    public onDocInputFocus() {
        this.isDepDropdownOpen = false;
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = true;
    }
    public onDocDropdownOpened() {
        this.isDepDropdownOpen = false;
        // Закрываем другие дропдауны
        this.isSpecDropdownOpen = false;
        this.isDocDropdownOpen = true;
    }
    public onDocDropdownClosed() {
        this.isDocDropdownOpen = false;
    }

    @HostListener('document:click', ['$event'])
    public handleClickOutside(event: MouseEvent) {
        const clickedInside =
            event.target instanceof HTMLElement &&
            (event.target.closest('.custom-input') ||
                event.target.closest('.custom-dropdown'));

        if (!clickedInside) {
            this.isSpecDropdownOpen = false;
            this.isDocDropdownOpen = false;
            this.isDepDropdownOpen = false;
        }
    }
    public closeFilter(): void {
        this.filterChecked = false;
        this.filterCheckedChange.emit(false);
    }
    public isPdfLoading(keyId: number): boolean {
        return !!this.pdfLoadingMap[keyId];
    }
    private setPdfLoading(keyId: number, value: boolean): void {
        this.pdfLoadingMap = {
            ...this.pdfLoadingMap,
            [keyId]: value,
        };
    }
}
